import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Serverurl from './Apiurl';
import IconButton from '@mui/material/IconButton';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import OTPInput from 'react-otp-input';
import { auth,firebase  } from "../firebaseotp";
import Athalogo from './images/logo-bg.png';
import FormControl from '@mui/material/FormControl';
import { ReactComponent as Visibility } from './images/visibility.svg';
import { ReactComponent as VisibilityOff } from './images/visibilityoff.svg';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Input from '@mui/material/Input';
export default class Forgot extends Component {
	constructor(props) {
    super(props);
	this.state = {redirect:false,pagename:'',pnlmsg:false,msgtext:'',errormessage:'',erroropen:false,alerttype:'error',btndisabled:false,btntext:'Submit',pnlform1:false,registermsg:false,
	emailid:'',btnverifytext:'Verify',pnlreset:false,showPassword:false,conshowPassword:false,Password:'',confPassword:'',btnrestdisabled:false,btnresttext:'Reset',}
	
	}
	handleChange = event => {
let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 };
 handleErrorclose=(event)=>{
	  
	this.setState({erroropen: false});  
  }

componentDidMount() {
	let search = window.location.href;
		
	let UserId = this.getParameterByName('UserId',search);
	if(UserId!==null)
	{
	this.setState({emailid: UserId});
	}	
}
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
generateRecaptcha= () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      }
    }, auth);
  }
OnclickForgot =(event)=>{
	 event.preventDefault();
	
	 let emailid = this.state.emailid;
	var self=this;
	     if(emailid==="")
{
	this.setState({errormessage:"Please Enter Phone No.",erroropen:true});
	return false;
}
 self.generateRecaptcha();
 let appVerifier = window.recaptchaVerifier;
 

   var formData = new FormData();
   this.setState({btndisabled:true,btntext:'Processing...',errormessage:'',erroropen:false});
    formData.append('action','forgot')
		formData.append('cu_emailid',emailid)
	
	
	 axios.post(Serverurl+"ajaxcustomer.php", formData, { 
	 }).then(res => {
		 this.setState({btndisabled:false,btntext:'Submit',msgtext:'' });
		 let strreturn=res.data 	;	 
 

 if (strreturn === -1)
        {	 window.scrollTo({        top: 0     })
			this.setState({pnlmsg:true,msgtext:"This phone no. does not belongs to any account!  Make sure that it is typed correctly."})
			
		}
		else
		{
			
			if(strreturn===0)
		{ console.log(appVerifier);
			signInWithPhoneNumber(auth,"+91"+emailid,appVerifier)
            .then((confirmationResult) => {
            
			   
                
			     window.confirmationResult= confirmationResult;
			this.setState({pnlform1:true,registermsg:true});
				localStorage.setItem("AYfEmail",emailid);
			
			})
            .catch((err) => {
                //alert(err);
                window.location.href=window.location.href;
            });
			 
					//this.setState({redirect:true,pagename:"/Resetpassword",pnlforgot:false})	
		}
		else if(strreturn===1)
		{	 window.scrollTo({        top: 0     })
					this.setState({pnlmsg:true,msgtext:"<a style='color:Red!important;' href='#/Regsiteration?Uname=" + emailid + "'>Your email is not verified <span className='messagetxt'>please click here</span> to verify your account</a>",pnlforgot:false})	
		}
		else if(strreturn===2)
		{	 window.scrollTo({        top: 0     })
					this.setState({pnlmsg:true,msgtext:"Your account has been blocked. Please contact admin to activate",pnlforgot:false})	
		}
		}
		 
	 })
}
OnclickVerify=(event)=>{
    event.preventDefault();

	 let otp=this.state.otp;
	 var self=this;
		   
 
if (otp === '' ) {
		
		this.setState({errormessage:"Please Enter OTP",erroropen:true});
			 window.scrollTo({        top: 0     })
		return false;
	 }
	
	  let confirmationResult1 = window.confirmationResult;
      confirmationResult1.confirm(otp).then((result) => {
        // User signed in successfully.
        let user = result.user;
    
	   // this.setState({redirect:true,pagename:"/Resetpassword",pnlforgot:false})
		this.setState({pnlmsg:true,msgtext:"Your account is verified, please reset your password",pnlreset:true,pnlforgot:false,registermsg:false})		
			
      }).catch((error) => {
	   this.setState({btnverdisabled:false,btnverifytext:'Verify',errormessage:"Please Enter Valid OTP",erroropen:true});
			 window.scrollTo({        top: 0     })
		return false;
      });
	 
	
	  
	  
}
  
  generateRecaptcha2= () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha2', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      }
    }, auth);
  }
  
    setOtp(val)
  {
	this.setState({otp: val});    
  }
handleotpChange =(OTP) => {
	 const repho = /^[0-9\b]+$/;
	 let strotp="";
	 if(repho.test(OTP)){
		strotp= OTP;
	 }
	if(strotp!==" "){
	
	this.setOtp(strotp);
	}
	//this.setState({otp: OTP});
}
handleresendSubmit= (event) => {
	
	let phone=localStorage.getItem("AYEmail");
	
			
if(phone===null || phone==="")
	{
			this.setState({errormessage:"Please Enter Valid 10 Digit Mobile No.",erroropen:true});
		 window.scrollTo({        top: 0     })	
		 return false;
	}
	 this.generateRecaptcha2();
 let appVerifier = window.recaptchaVerifier;		
		 signInWithPhoneNumber(auth,'+91'+phone,appVerifier)
            .then((confirmationResult) => {
               // setfinal(result);
			   
                console.log(confirmationResult);
			     window.confirmationResult= confirmationResult;
	
               // setshow(true);
            })
            .catch((err) => {
                
                window.location.reload();
            });	
}

handleClickShowPassword = () => {
    
	this.setState({
            showPassword: !this.state.showPassword
          })
  };
	handleClickconPassword = () => {
    
	this.setState({
            conshowPassword: !this.state.conshowPassword
          })
  };
OnclickRestPass =(event)=>{
	 event.preventDefault();
let Password = this.state.Password;
let confPassword = this.state.confPassword;
let emailid = this.state.emailid;
 if(Password==="")
{
	this.setState({errormessage:"Please Enter Password",erroropen:true});
		 window.scrollTo({        top: 0     })
	return false;
}else{
	if(Password.length<6)
	{
		this.setState({errormessage:"Please Enter Strong Password.",erroropen:true});
			 window.scrollTo({        top: 0     })
	return false;
	}
}

 if(confPassword!==Password)
{
	this.setState({errormessage:"Please ReType Correct Password",erroropen:true});
	return false;
}
  this.setState({btnrestdisabled:true,msgtext:'',btnresttext:'Processing...',errormessage:'',erroropen:false});
var formData = new FormData();
 
    formData.append('action','customerresetpassword')
	formData.append('cu_emailid',localStorage.getItem("AYfEmail"))
	formData.append('cu_password',confPassword)
	axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
				 window.scrollTo({        top: 0     })
			localStorage.removeItem("AYfEmail")
			 this.setState({btnrestdisabled:false,btnresttext:'Reset',pnlreset:false,pnlmsg:true,
			
	 msgtext:"Password has been changed succesfully. <a href='close.html'  className='secondlinks'>Click here to Sign In</a>",})
			
		});
}

	 render(){
		  let msgtext=this.state.msgtext;
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
	  return(
	   <div className="signin-bg">
	   <div className="signinlogo">
	  <img src={Athalogo} alt="Atha Yoga" />
	  </div>
	  <div className="regformbg"> <div className="regform">
	     {this.state.pnlform1===false &&(
	  <h2>Forgot Password</h2>
	  
		 )}
		  {this.state.registermsg===true &&(
		    <h2>Verify Phone Number</h2>
		   )}
		   {this.state.pnlreset===true &&(
		   
		   <h2>Reset Password</h2>
		   )}
		   
	  <p>  <Collapse in={this.state.erroropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	   {this.state.pnlmsg===true && (
	  <div className="formright">
	  <div dangerouslySetInnerHTML={ { __html: msgtext}} className="messagetxt"/>
	  </div>
	  
	  )}
	   {this.state.pnlform1===false &&(<div>
	   <p>
	 <TextField id="emailid" type="number" name="emailid"  variant="outlined"  className="signinptmob"  placeholder="Your Phone No."
            fullWidth inputProps={{maxLength:150,  }} 
			value={this.state.emailid}  onChange={this.handleChange}/> 
	 
	 </p>  <div id="recaptcha"></div><p><Button
            type="submit"
            fullWidth
			disabled={this.state.btndisabled}
            variant="contained" 
       className="primarybtncolr"
           id="searchform" 
		onClick={this.OnclickForgot}
           
          >
           {this.state.btntext} 
          </Button>
		  </p> <p className="signuplink linkcolor sublinetext">Have an account?	<a href="close.html" className="secondlinks">Sign In</a>
	 </p>
		  
	</div> )}
	 
	  {this.state.registermsg===true &&(
	  <div id="pnlmsg" >
	  <div className="messagetxt">
 <p> An OTP has been sent to your phone no.</p>
<p>Please check your phone and enter the OTP activate your account.</p> 

</div> <div id="recaptcha2"></div>
<OTPInput
            onChange={this.handleotpChange}
            value={this.state.otp} 
            inputStyle="inputStyle"
            numInputs={6}
            separator={<span></span>}
			 renderInput={(props) => <input {...props} type="number"/>}
          /> <div id="recaptcha1"></div>
	 <p className="signbutnleft">

<Button
            type="submit" fullWidth
            className="secondbtncolr"
            variant="contained" 
            color="primary"
            onClick={this.handleresendSubmit}
          >
          Resend 
          </Button>

		  </p>
  <div id="recaptcha2"></div>
<p className="signbutnright">
<Button
            type="submit"
            fullWidth  placeholder="*"
			disabled={this.state.btnverdisabled}
            variant="contained" 
             className="primarybtncolr"
           id="searchform" 
		onClick={this.OnclickVerify}
           
          >
           {this.state.btnverifytext} 
          </Button>
</p>
<div className="clear"></div>
		  </div>
	  )}
	  
	  {this.state.pnlreset===true &&(<React.Fragment>
	   <p>
	 	 <FormControl fullWidth variant="outlined" className="signinpt" 	inputlabelprops={{ shrink: false }}>
         
          <Input 
             id="Password" name="Password"   value={this.state.Password} placeholder="Password"
            type={this.state.showPassword ? 'text' : 'password'}  onChange={this.handleChange}
		
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p>
	 <p>
	 	 <FormControl  fullWidth  className="signinpt">
         
          <Input inputlabelprops={{ shrink: true }} 
             id="confPassword" name="confPassword"   value={this.state.confPassword} placeholder="Confirm Password"
            type={this.state.conshowPassword ? 'text' : 'password'}  onChange={this.handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickconPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
                >
                  {this.state.conshowPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p><p><Button
            type="submit"
            fullWidth
			disabled={this.state.btnrestdisabled}
            variant="contained" 
             className="primarybtncolr"
           id="searchform" 
		onClick={this.OnclickRestPass}
           
          >
           {this.state.btnresttext} 
          </Button>
		  </p></React.Fragment>)}
	  
	  </div> </div></div>
	  )
	}
}

